const doc = [({"zh_cn":({"adminConstantHotelChildrenSettingType":({"complexChildrenSetting":"按子类别分开设置", "empty":"无设置", "none":"儿童不可住宿", "simpleChildrenSetting":"年龄自由设置，设置为儿童（+婴儿）"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;